import type { ChronikSortierung } from '@genealogy-app/shared';
import apiClient from '@/api/client';

// ─── Chronik herunterladen ───────────────────────────────────────────────────
//
// Das PDF entsteht auf dem Server; hier wird es nur entgegengenommen und dem
// Browser zum Speichern gegeben. Der Dateiname kommt aus der Antwort – so
// steht der Name des Stammbaums darin, ohne ihn hier ein zweites Mal zu bilden.

export interface ChronikErgebnis {
  dateiname: string;
  bilder: number;
  /** Kapitel im Buch – Generationen, Buchstaben oder Jahrhunderte, je nach Ordnung. */
  kapitel: number;
}

export async function ladeChronik(
  sortierung: ChronikSortierung = 'generationen',
): Promise<ChronikErgebnis> {
  const antwort = await apiClient.get('/chronik', {
    responseType: 'blob',
    params: { sortierung },
  });

  const kopf = String(antwort.headers['content-disposition'] ?? '');
  const dateiname = /filename="([^"]+)"/.exec(kopf)?.[1] ?? 'Chronik.pdf';

  const url = URL.createObjectURL(antwort.data as Blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = dateiname;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Erst freigeben, wenn der Download angestoßen ist – sofortiges revoke
  // bricht ihn in manchen Browsern ab.
  setTimeout(() => URL.revokeObjectURL(url), 10_000);

  return {
    dateiname,
    bilder: Number(antwort.headers['x-chronik-bilder'] ?? 0),
    kapitel: Number(antwort.headers['x-chronik-kapitel'] ?? 0),
  };
}
